export default __webpack_public_path__ + "static/media/dt2.ff26885b.webp";